module.exports = __webpack_public_path__ + "media/images/Candle-With-Tealight-no-wick-067a6ffed0a4498184b01e75c023431d.png";